import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiState } from "../../apis/index";
import { ApiHome } from "../../apis/home";
import { AppActions } from "../store";

const _sliceName = 'userHomes';
const _initialState = {};

const UserHomesSlice = createSlice({
    name: _sliceName,
    initialState: { ..._initialState },
    reducers: {
        setLoading: (state, action) => {
            const { userId } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toLoading().toOb()
            };
        },
        setSuccess: (state, action) => {
            const { userId, data } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toComplete(data).toOb(),
            };
        },
        setError: (state, action) => {
            const { userId, error } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toError(error).toOb(),
            };
        },
    },
});


const UserHomesSliceRefreshThunk = createAsyncThunk(
    `${_sliceName}/refresh`,
    (userId, thunkApi) => {

        try {
            userId = userId || thunkApi.getState()?.auth?.user?._id;
            const dispatch = thunkApi.dispatch;
            dispatch(UserHomesSlice.actions.setLoading({ userId }));
            return ApiHome.list().then((data) => {
                const homes = data.homes;
                const homeIds = homes.map((e)=>e._id);
                dispatch(AppActions.db.updateList(data.homes || []));
                dispatch(UserHomesSlice.actions.setSuccess({
                    userId,
                    data : homeIds
                }));
            }).catch((err) => {
                dispatch(UserHomesSlice.actions.setError({
                    userId,
                    error : err+""
                }));
            });

        } catch (e) {
            console.warn(e);
        }


    },
);


export { UserHomesSlice, UserHomesSliceRefreshThunk }